export class SaveStatusParam {
    // long LearningUnitAttemptID, short StatusID, string APIKey
    public LearningSessionDetailID!: number;
    public AuthorizationID!: string;
    public BookMarkId!: string;

}